import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'

import Section from 'components/layout/content/section'
import Drawer from 'components/layout/drawer'
import InvocationsList from './list'
import InvocationDetails from './details'
import Filter from './filter'
import { INVENTORY_SERVICES } from 'lib/resources/constants'
import { Breakpoint, useResize } from 'hooks/resize'

import LoadMore from 'components/items/load-more'
import { useLimit } from 'hooks/limit'

const InvocationsContainer = ({
  durationFilter,
  setDurationFilter,
  memoryFilter,
  setMemoryFilter,
  invocations,
  service,
  resource,
  setFilter,
  filter,
  title,
  actions,
  onSelect,
  onClose,
  itemClassName,
  loading,
  editorState,
  setEditorState,
  onSearch,
  searchEnabled,
  url,
  hideFilters = false,
  hash,
  logMatch,
  className
}) => {
  const match = useRouteMatch()
  const { isVisibleUntil } = useResize()
  const { getLimitedItems, isLimited, setEnabled } = useLimit(isVisibleUntil(Breakpoint.lg), 5)

  if (searchEnabled && !editorState) {
    throw new Error('editorState is required when searchEnabled is true')
  }

  const invocationPath = `${match.path}/requests/:invocationHash`
  const requestPath = `${match.path}/requests/:requestId`
  const logMatchPath = `${match.path}/log-matches/:invocationHash`

  return (
    <Section
      title={title || ''}
      actions={actions}
      className={className}
      titleUpperCase
    >
      {!hideFilters && (
        <Filter
          resource={resource}
          searchEnabled={searchEnabled}
          filter={filter} setFilter={setFilter}
          durationSliderValue={durationFilter} setDurationSliderValue={setDurationFilter}
          memorySliderValue={memoryFilter} setMemorySliderValue={setMemoryFilter}
          editorState={editorState} setEditorState={setEditorState} onSearch={onSearch} />
      )}
      <InvocationsList
        loading={loading}
        type={service}
        items={getLimitedItems(invocations)}
        onSelect={onSelect}
        url={url}
        itemClassName={itemClassName}
      />
      <LoadMore show={isLimited} setShow={setEnabled} />
      <Route path={service === INVENTORY_SERVICES.AppSyncGraphQLApi.id
        ? requestPath
        : logMatch
          ? logMatchPath
          : invocationPath}
      >
        <Drawer
          onClose={onClose}
          size='large'
          expandable
        >
          <InvocationDetails
            type={service}
            resource={resource}
            onClose={onClose}
            hash={hash}
          />
        </Drawer>
      </Route>
    </Section>
  )
}

export default InvocationsContainer
